import React, { useEffect, useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";

import "./shareInput.scss";

const CopyInput = ({ mailLink }) => {
  const { getTextByKey } = useContent();
  const { getMailMetaData } = useMail();
  const shareLinkFieldRef = useRef();
  const [copiedAlert, setCopiedAlert] = useState(false);
  const [width, setWidth] = useState(0);
  const [link, setLink] = useState("");

  useEffect(() => {
    const notTest = process.env.REACT_APP_STAGE?.trim() !== "test";
    const currentLink = mailLink || getMailMetaData().shortUrl;
    if (notTest && currentLink.includes("jubmomail.me")) {
      const testLink = currentLink.replace("jubmomail.me", "test.jumbomail.me");
      setLink(testLink);
    } else {
      setLink(currentLink);
    }
  }, [mailLink, getMailMetaData().shortUrl]);

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(link);
    } else if (shareLinkFieldRef.current) {
      shareLinkFieldRef.current.focus();
      shareLinkFieldRef.current.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        setCopiedAlert(false);
      }
      shareLinkFieldRef.current.blur();
    }
    setCopiedAlert(true);
    setTimeout(() => {
      setCopiedAlert(false);
    }, 4000);
  };

  useEffect(() => {
    setWidth(link.length + "ch");
  }, [link]);

  return (
    <>
      <div className="share-input">
        <input
          id="input"
          type="text"
          value={link}
          ref={shareLinkFieldRef}
          onChange={() => null}
          style={{
            backgroundColor: !link
              ? "transparent"
              : copiedAlert
              ? "rgba(80,210,100, 0.2)"
              : "rgb(110, 190, 200, 0.2)",
            width: width,
          }}
        />
        {link.length > 0 ? (
          <Tooltip
            id={"copyLinkIcon"}
            tooltipTextKey="copy-icon-tooltip-text"
            top
          >
            <Icon name="copy" blue onClick={handleCopy} />
          </Tooltip>
        ) : null}
        <AnimationContainer
          animationOn={copiedAlert}
          animationClassName="fade-in"
        >
          <div className="copied-alert-text" onClick={handleCopy}>
            {getTextByKey("copy-link-success")}
          </div>
        </AnimationContainer>
      </div>
    </>
  );
};
export default CopyInput;
